function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Queue that uses localstorage to buffer events.
 */
var Queue = /*#__PURE__*/function () {
  /**
   * Constructor requires a localstorage key to buffer events, format: ab_events-buffer-for-[service name].
   *
   * Example: ab_events-buffer-for-mixpanel
   * @param name
   */
  function Queue(name) {
    _classCallCheck(this, Queue);
    if (!name) {
      throw new Error('Queue requires a key name to buffer events in a localstorage (e.g. ab_events-buffer-for-mixpanel)');
    }
    this.name = name;
    this.storage = JSON.parse(localStorage.getItem(this.name) || '[]');
  }

  /**
   * Add a new event to a localstorage buffer.
   * @param event
   */
  _createClass(Queue, [{
    key: "enqueue",
    value: function enqueue(event) {
      this.storage.push(event);
      localStorage.setItem(this.name, JSON.stringify(this.storage));
    }

    /**
     * Remove the oldest event from a localstorage buffer.
     * @returns {IEvent} Returns event
     */
  }, {
    key: "dequeue",
    value: function dequeue() {
      // Get the oldest event (we mutate array)
      // NOTE: The max size of this array will be up to 5-10 elements and only when a race condition happans
      //       which is 5% of the time. The rest of the time this array will be emtpy as events will be
      //       dispatched directly to analytics 3rd party (e.g. MixPanel).
      var oldestEvent = this.storage.shift();
      localStorage.setItem(this.name, JSON.stringify(this.storage));
      //@ts-expect-error TODO: fix this
      return oldestEvent;
    }

    /**
     * Get a number of events in a localstorage buffer.
     * @returns
     */
  }, {
    key: "size",
    value: function size() {
      return this.storage.length;
    }
  }]);
  return Queue;
}();
export { Queue as default };